import { Dispatch, FC, SetStateAction, useMemo } from "react";
import {
    SearchBar,
    SearchBarDataHandler,
} from "../../../../../assets/components/SearchBar/SearchBar";
import { Products } from "../../../../../models/models";
import { OptionList } from "../../../../../assets/helpers/helpers";

interface Props {
    products?: Products;
    dataHandler: Dispatch<SetStateAction<SearchBarDataHandler>>;
    dateRange: {
        startDate: SearchBarDataHandler["startDate"];
        endDate: SearchBarDataHandler["endDate"];
    };
}
const LicenseKeysNotActivatedSearchBar: FC<Props> = ({
    products,
    dataHandler,
    dateRange,
}) => {
    const productsOptionList: OptionList = useMemo(() => {
        return products?.map(({ name, id }) => {
            return {
                id,
                name,
            };
        }) as OptionList;
    }, [products]);

    const timeOptionsOptionList: OptionList = useMemo(() => {
        return [
            { id: 1, name: "Last 24 hours" },
            { id: 2, name: "Last 7 days" },
            { id: 3, name: "Last 1 month" },
        ];
    }, []);

    return (
        <SearchBar
            productOptions={productsOptionList}
            dateRangeOptions={timeOptionsOptionList}
            initialData={{
                dateRange,
            }}
            dataHandler={dataHandler}
            searchInput={{
                placeholder: "License key",
            }}
            searchByOrderId={{
                placeholder: "Order ID",
            }}
            showComponents={{
                dataPikerDateRange: true,
            }}
        />
    );
};

export default LicenseKeysNotActivatedSearchBar;
